import React from 'react';
import Btn from '../Common/Btn';
import './CutsceneTemplate.css'

import Next from '../../Assets/Icons/Next.svg'

const CutsceneTemplat = (props) => {
    return ( 
        <section className={props.TemplateClass}>
            
            <div className='DialogueBox'>
                <img src={props.DialogueImg} alt="" />

                <div className='DialogueContent'>

                    <div className='DialogueText'>
                        <p className='DialogueName'>
                            {props.DialogueName}
                        </p>

                        <p className='DialogueP'>
                            {props.DialogueP}
                        </p>
                    </div>
                    

                    <Btn BtnStyle='NextBtn' BtnIcon={Next} onClick={props.NextBtnChange}/>
                </div>
            </div>
        </section>
     );
}
 
export default CutsceneTemplat;